
export enum SUPPLY_SPECIALTY_ID {
   SUPPLY_SPECIALTY = 1,
}
